export const iconFontAwesomeMediaplaybackBackward = (
	<i className="fa-solid fa-backward"></i>
);
